import { Loader2 } from "lucide-react"
import { createPortal } from "react-dom"

import { cn } from "@/lib/utils"

interface LoadingOverlayProps {
  // Optional label shown under the spinner.
  message?: string
  className?: string
}

// Full-viewport blocking overlay. Render it conditionally while a long-running
// action is in flight to prevent the user from doing anything else until it
// completes. Portaled to <body> so it isn't clipped by positioned ancestors.
export function LoadingOverlay({ message, className }: LoadingOverlayProps) {
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 bg-black/40 backdrop-blur-sm",
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-white" />
      {message && <p className="text-sm font-medium text-white">{message}</p>}
    </div>,
    document.body
  )
}
